// パスナビへのリンクを非表示にする大学コードのリスト
export const HIDE_PASSNAVI_LINK_UNIVERSITY_IDS = ['D0230', 'D1200', 'D1210', 'D4210', 'D9999', 'D1640', 'D4770', 'D9900'];
